module.exports = __webpack_public_path__ + "static/media/alarm-exclamation.49eb2cd2.svg";